import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import EditInputComponent from "../../components/EditInputComponent/EditInputComponent";
import * as React from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import {
  handleErrorState,
  skeletonHandler,
} from "../../HandleSlice/HandleSlice";
import CreateSkeleton from "../../components/CreateSkeleton/CreateSkeleton";
import { INTERNAL_PATHS } from "../../configs/routes.config";
import { Toastify } from "../../utils/function.utils";
import Error from "../../components/Error/Error";
import { ToastContainer } from "react-toastify";

function useForceUpdate() {
  const [value, setState] = useState(true);
  return () => setState(!value);
}

const DynamicCreatePage = () => {
  const [inputData, setInputData] = useState({});
  const [editData, setEditData] = useState([]);
  const [errorsValidation, setErrorsValidation] = useState({});
  const [selectSearchData, setSelectSearchData] = useState({});
  const [selectDynamicData, setSelectDynamicData] = useState({});
  const [selectRouteMultipleKeys, setSelectRouteMultipleKeys] = useState({});
  const [
    selectAllSelectSearchMultiplekeys,
    setSelectAllSelectSearchMultiplekeys,
  ] = useState({});
  const [required, setRequired] = useState([]);
  const handleForceupdateMethod = useForceUpdate();
  const location = useParams();
  const data = useSelector((data) => data.hamberger);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dataState = useSelector((state) => state.hamberger);

  function objectMakerHandler() {
    let isRequired = 0;
    required.map((item) => {
      if (inputData[item.key] === "") {
        isRequired = 1;
        Toastify("error", `فیلد ${item.label} وارد نشده`);
      }
    });
    if (isRequired === 0) {
      selectRouteMultipleKeys.map((item) => {
        inputData[item] = inputData[item].map((item2) => {
          return item2.value;
        });
      });
      selectAllSelectSearchMultiplekeys.map((item) => {
        inputData[item] = inputData[item].map((item2) => {
          return item2.value;
        });
      });
      dispatch(handleErrorState(""));
      axios
        .post(`/${location.model}`, inputData)
        .then(() => {
          navigate(`/${location.model}`);
          Toastify("success", "اطلاعات با موفقیت ثبت شد");
        })
        .catch((e) => {
          if (e.response.status === 422) {
            setErrorsValidation(e.response.data.errors);
          }
        });
    }
  }

  useEffect(() => {
    dispatch(skeletonHandler(true));
    axios(`/${location.model}${INTERNAL_PATHS.CREATE}${window.location.search}`)
      .then((response) => {
        setEditData(response.data);
        let array1 = response.data.schema.form.filter((item) => {
          if (item.controlType === "select_route_multiple") {
            return item;
          }
        });
        let array2 = array1.map((item) => {
          return item.key;
        });

        let array3 = response.data.schema.form.filter((item) => {
          if (item.controlType === "select_all_select_search_multiple") {
            return item;
          }
        });

        let array4 = array3.map((item) => {
          return item.key;
        });


        setSelectRouteMultipleKeys(array2);
        setSelectAllSelectSearchMultiplekeys(array4);
      })
      .then(() => {
        dispatch(skeletonHandler(false));
      })
      //TODO 404 500
      .catch((e) => {
        if (e.response.status === 422) {
          setErrorsValidation(e.response.data.errors);
        }
      });
  }, [dispatch, location.model]);

  function cancelMakerHandler() {
    navigate(`/${location.model}`);
    Toastify("error", "اطلاعات ثبت شده لغو شد");
  }

  useEffect(() => {
    let object = {};
    editData.schema &&
      editData.schema.form.forEach((item) => {
        if (item.controlType === "permission") {
          object[item.key] = [null];
        } else if (item.controlType === "multiple_image") {
          object[item.key] = [];
        } else if (item.controlType === "select_route_multiple") {
          object[item.key] = [];
        } else {
          object[item.key] = "";
        }
      });
    setInputData(object);
  }, [editData]);

  return (
    <>
      {dataState.errorState === 404 || dataState.errorState === 500 ? (
        <Error error={dataState.errorState} />
      ) : (
        ""
      )}
      <div className="bg-body_background dark:bg-[#152A38] w-[calc(100%)] 900:mr-[238px] 900:w-[calc(100%-238px)] pt-[90px] pb-5">
        <div
          className={`bg-component_background shadow-box dark:bg-[#29435C] rounded-[12px] px-[25px] pb-[25px] pt-2 sm:pt-[25px] m-auto mt-2 sm:mt-10 w-[90%] sm:w-[80%]`}
        >
          <h2 className="text-[14px] font-extrabold">
            <i className={`${editData.icon}`}></i> {editData.title}
          </h2>
          <div
            className={
              "grid grid-cols-1 560:grid-cols-12 justify-between items-start gap-x-7 sm:gap-y-7"
            }
          >
            {editData.length !== 0
              ? editData.schema.form.map((item, index) => (
                  <EditInputComponent
                    item={item}
                    key={item.key}
                    inputData={inputData}
                    setInputData={setInputData}
                    index={index}
                    pageType="create"
                    locationModel={location.model}
                    setSelectSearchData={setSelectSearchData}
                    selectSearchData={selectSearchData}
                    setSelectDynamicData={setSelectDynamicData}
                    selectDynamicData={selectDynamicData}
                    handleForceupdateMethod={handleForceupdateMethod}
                    matchpointId={"matchpoint" + index}
                    id={`${item.controlType}-${index}`}
                    setRequired={setRequired}
                    required={required}
                  >
                    {errorsValidation[item.key]}
                  </EditInputComponent>
                ))
              : ""}
            {data.skeletonState && <CreateSkeleton />}
            <div className={"280:flex justify-end col-span-full mt-8 sm:mt-0"}>
              <div onClick={objectMakerHandler}>
                <button
                  className={
                    "ml-5 w-[80px] 560:w-[120px] text-center h-[38px] rounded-[3px] bg-confirm_button_background text-confirm_button_text hover:bg-confirm_button_background_hover border border-confirm_button_border "
                  }
                >
                  <i className="fa fa-check" aria-hidden="true"></i>
                  <span className="inline-block mr-1">ثبت</span>
                </button>
              </div>
              <div onClick={cancelMakerHandler}>
                <button
                  className={
                    "w-[80px] 560:w-[120px] text-center h-[38px] rounded-[3px] border border-cancel_button_border dark:bg-[#ff8992] dark:text-white dark:hover:bg-[#fd727d] bg-cancel_button_background text-cancel_button_text hover:bg-cancel_button_background_hover mt-5 280:mt-0"
                  }
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                  <span className="inline-block mr-1">لغو</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default DynamicCreatePage;
